// Opciones de la coleccion `channels` (valores reales únicos)
export const CONTENT_TYPES = [
    { value: 'ebook', label: 'Ebook' },
    { value: 'audiobook', label: 'Audiolibro' },
    { value: 'pod', label: 'POD' },
];

export const TYPE_EBOOK = [
    { value: 'epub_2_reflowable', label: 'EPUB 2 Reflowable' },
    { value: 'epub_3_reflowable', label: 'EPUB 3 Reflowable' },
    { value: 'epub_2_fixed', label: 'EPUB 2 Fixed' },
    { value: 'epub_3_fixed', label: 'EPUB 3 Fixed' },
    { value: 'pdf', label: 'PDF' },
];

export const CLIENT_TYPES = [
    { value: 'editorial', label: 'Editorial' },
    { value: 'self_published', label: 'Self-published' },
];

// Etiquetas de los campos que el backend exige para considerar completo un canal.
export const REQUIRED_FIELD_LABELS = {
    name: 'Nombre',
    alias: 'Alias',
    content: 'Tipo de contenido',
    client_type: 'Tipo de cliente',
    type_ebook: 'Formatos ebook',
    requirements_audiobook: 'Formatos audiolibro',
};

export const ALLOW_NO_ISBN = 1;

export const FILE_TYPES = [
    { value: 'csv', label: 'CSV' },
    { value: 'txt', label: 'TXT' },
    { value: 'xls', label: 'XLS' },
    { value: 'xlsx', label: 'XLSX' },
];

export const DISTRIBUTIONS = [
    { value: 'stock', label: 'Stock' },
    { value: 'pod', label: 'POD' },
];

export const STATUS_METHODS = [
    { value: 'equal', label: 'equal' },
    { value: 'like', label: 'like' },
];

export const LINK_METHODS = [
    { value: 'build', label: 'build' },
    { value: 'get', label: 'get' },
];

export const AUDIOBOOK_FORMATS = [
    { value: 'mp3', label: 'MP3' },
    { value: 'wav', label: 'WAV' },
];

// Conexiones SFTP/FTP (subdocumento `connections` del canal)
export const CONNECTION_PROTOCOLS = [
    { value: 'sftp', label: 'SFTP' },
    { value: 'ftp', label: 'FTP' },
];

export const CONNECTION_CONTENT_TYPES = [
    { value: 'all', label: 'Todos' },
    { value: 'ebook', label: 'Ebook' },
    { value: 'audiobook', label: 'Audiolibro' },
];

export const CONNECTION_ISBN_TYPES = [
    { value: 'all', label: 'Todos' },
    { value: 'con', label: 'Con ISBN' },
    { value: 'sin', label: 'Sin ISBN' },
];

export const CONNECTION_MODELS = [
    { value: 'all', label: 'Todos' },
    { value: 'retail', label: 'Retail' },
    { value: 'lending', label: 'Lending' },
    { value: 'agency', label: 'Agency' },
];

export const DEFAULT_CONNECTION_PORT = { sftp: 22, ftp: 21 };

export const EMPTY_CONNECTION = {
    _id: '',
    name: '',
    protocol: 'sftp',
    host: '',
    port: 22,
    user: '',
    password: '',
    has_isbn: 'all',
    content_type: 'all',
    model: 'all',
    has_password: false,
};

export const EMPTY_CHANNEL = {
    _id: undefined,
    name: '',
    alias: '',
    active: false,
    content: [],
    type_ebook: [],
    requirements_ebook: {
        restriction_into: {
            epubs: {},
            pdf: {},
        },
        limit_page: { min: 0, max: -1 },
        limit_price: { min: 0, max: -1 },
        limit_size: { min: 0, max: -1 },
    },
    requirements_audiobook: {
        formats: [],
        sample: 0,
    },
    client_type: [],
    allow_no_isbn: 0,
    advice: '',
    advice_en: '',
    allowed_categories: {
        bisac: [],
        thema: [],
    },
    config_report: {
        file_type: 'xlsx',
        init_row: 1,
        columns: [],
        identifiers: [],
        status: {
            column: '',
            method: 'equal',
            on: [],
            off: [],
        },
        link: {
            method: 'get',
            column: '',
        },
        distribution: 'stock',
    },
};